import React, { useMemo } from 'react';
import Table from '../../../../components/tables/Table';
import { standardDateFormat } from '../../utils/operatorexports.helpers';

const d = new Date();
const todayDate = standardDateFormat(d);

d.setDate(d.getDate() - 1);
const oneDayAgoDate = standardDateFormat(d);

d.setDate(d.getDate() - 1);
const twoDaysAgoDate = standardDateFormat(d);

d.setDate(d.getDate() - 1);
const threeDaysAgoDate = standardDateFormat(d);

d.setDate(d.getDate() - 1);
const fourDaysAgoDate = standardDateFormat(d);

d.setDate(d.getDate() - 1);
const fiveDaysAgoDate = standardDateFormat(d);

d.setDate(d.getDate() - 1);
const sixDaysAgoDate = standardDateFormat(d);

d.setDate(d.getDate() - 1);
const sevenDaysAgoDate = standardDateFormat(d);

d.setDate(d.getDate() - 1);
const eightDaysAgoDate = standardDateFormat(d);

d.setDate(d.getDate() - 1);
const nineDaysAgoDate = standardDateFormat(d);

const COLUMNS = [
  { label: 'Operator Code', field: 'operatorCode', sortable: true, type: 'string' },
  { label: nineDaysAgoDate, field: 'nineDaysAgo', sortable: true, type: 'string' },
  { label: eightDaysAgoDate, field: 'eightDaysAgo', sortable: true, type: 'string' },
  { label: sevenDaysAgoDate, field: 'sevenDaysAgo', sortable: true, type: 'string' },
  { label: sixDaysAgoDate, field: 'sixDaysAgo', sortable: true, type: 'string' },
  { label: fiveDaysAgoDate, field: 'fiveDaysAgo', sortable: true, type: 'string' },
  { label: fourDaysAgoDate, field: 'fourDaysAgo', sortable: true, type: 'string' },
  { label: threeDaysAgoDate, field: 'threeDaysAgo', sortable: true, type: 'string' },
  { label: twoDaysAgoDate, field: 'twoDaysAgo', sortable: true, type: 'string' },
  { label: oneDayAgoDate, field: 'oneDayAgo', sortable: true, type: 'string' },
  { label: todayDate, field: 'today', sortable: true, type: 'string' },
];

export default function OperatorExportTable({ rows = [], refreshing = false }) {
  const columns = useMemo(() => COLUMNS, []);
  const defaultSort = { field: null, direction: 'asc' };

  return (
    <Table
      rows={Array.isArray(rows) ? rows : []}
      columns={columns}
      stickyHeader
      zebra
      bordered
      hover

      defaultSort={defaultSort}
    />
  );
}
